firebird.controller('electronScreenModalCtrl', [
    '$rootScope',
    '$scope',
    '$window',
    '$timeout',
    'logService',
    'helperService',
    'supportLinkService',
    'macSecurityPreferencesService',
    function (
        $rootScope,
        $scope,
        $window,
        $timeout,
        logService,
        helperService,
        supportLinkService,
        macSecurityPreferencesService
    ) {
        var self = this;

        const logger = logService.createLoggerWithSource('electronScreenModalCtrl');

        self.modalState = 'closed';

        self.sources = [];
        self.appSources = [];
        self.share = share;
        self.openSystemPreference = openSystemPreference;
        self.clickSource = clickSource;
        self.doubleClickSource = doubleClickSource;
        self.previewScreenSelected = previewScreenSelected;
        self.previewScreenClear = previewScreenClear;

        self.possibleCatalinaError = false;
        self.showCatalinaError = false;
        self.isCatalina = false;
        self.catalinaHelpLink = supportLinkService.getSupportLink('catalinaScreenShare');
        self.isSettingsOpening = false;
        self.cancelSettingsOpeningTimeout = cancelSettingsOpeningTimeout;

        self.getUniqueSourceThumbId = getUniqueSourceThumbId;
        self.selectedSource = null;

        self.isScreenSource = isScreenSource;
        self.isOtherAppWindow = isOtherAppWindow;
        self.VDIRef = helperService.getVDIRef();
        self.screenShareSelected = false;

        self._onShowModal = onShowModal;
        self._onHideModal = onHideModal;

        $scope.$on('show-modal', onShowModal);
        $scope.$on('hide-modal', onHideModal);

        ////////////////////////

        init();

        function init() {
            $window.$('#screen-tab').tab('show');
            self.possibleCatalinaError = self.isCatalina = isElectronCatalina();
        }

        function onShowModal(e, modalName) {
            if (modalName === 'electronScreen') {
                return loadSources().then(() => {
                    self.modalState = 'open';
                    self.screenShareSelected = false;
                    digest();
                });
            }

            return Promise.resolve();
        }

        function onHideModal(e, modalName) {
            if (modalName.indexOf('electronScreen') !== -1) {
                self.cancelSettingsOpeningTimeout();

                self.modalState = 'closed';
                $rootScope.$broadcast('electron-screen-preview-destroy');
                if (e) {
                    if (!self.screenShareSelected) {
                        $rootScope.$broadcast('screen-share-init-cancel');
                    }
                    self.screenShareSelected = false;
                }
                digest();
            }
        }

        function getUniqueSourceThumbId(id) {
            return 'preview' + id.replace(/\W/gi, '');
        }

        function share() {
            if (self.selectedSource !== null) {
                $rootScope.$broadcast('electron-screen-selected', {
                    name: self.selectedSource.name,
                    id: self.selectedSource.id,
                    displayId: self.selectedSource.displayId
                });
                self.screenShareSelected = true;
                close();
            }
        }

        function openSystemPreference() {
            self.cancelSettingsOpeningTimeout();
            self.isSettingsOpening = true;

            self.settingsOpeningTimeout = $timeout(function () {
                close();
                self.isSettingsOpening = false;
            }, 10000);

            macSecurityPreferencesService.openScreenCapture();
        }

        function cancelSettingsOpeningTimeout() {
            if (self.settingsOpeningTimeout) {
                $timeout.cancel(self.settingsOpeningTimeout);
                self.settingsOpeningTimeout = null;
                self.isSettingsOpening = false;
            }
        }

        function clickSource(source) {
            if (helperService.getIsRedesign() === true) {
                var oldId = self.selectedSource !== null ? self.getUniqueSourceThumbId(self.selectedSource.id) : null;
                var newId = self.getUniqueSourceThumbId(source.id);
                self.selectedSource = source;

                //Empty timeout added in order for the element classes to get modified at the end of a digest cycle
                //(ensures the elements are on the page before modifying)
                $timeout(function () {
                    if (oldId !== null) {
                        $window.$('#' + oldId).removeClass('selected');
                    }
                    $window.$('#' + newId).addClass('selected');
                });
            } else {
                //TODO: REMOVE POST-REDESIGN
                $rootScope.$broadcast('electron-screen-selected', {
                    name: source.name,
                    id: source.id,
                    displayId: source.displayId
                });
                close();
            }
        }

        function doubleClickSource(source) {
            $rootScope.$broadcast('electron-screen-selected', {
                name: source.name,
                id: source.id,
                displayId: source.displayId
            });
            close();
        }

        function previewScreenSelected(source) {
            if (helperService.getIsRedesign() === true) {
                if (source.id.indexOf('screen:') === 0) {
                    $rootScope.$broadcast('electron-screen-preview', {
                        name: source.name,
                        id: source.id,
                        displayId: source.displayId
                    });
                }
            } else {
                //TODO: REMOVE POST-REDESIGN
                $rootScope.$broadcast('electron-screen-preview', {
                    name: source.name,
                    id: source.id,
                    displayId: source.displayId
                });
            }
        }

        function previewScreenClear(source) {
            if (helperService.getIsRedesign() === true) {
                if (source.id.indexOf('screen:') === 0) {
                    $rootScope.$broadcast('electron-screen-preview-clear');
                }
            } else {
                //TODO: REMOVE POST-REDESIGN
                $rootScope.$broadcast('electron-screen-preview-clear');
            }
        }

        function loadSources() {
            return new Promise(resolve => {
                // Add check for Citrix V4 environment and VDI reference
                if (helperService.isCitrixSDKVersionFour()) {
                    loadSources_citrixV4(resolve);
                    return;
                }

                // Original electron source retrieval code
                if (!$window.preloadedApi.desktopCapturer.isAvailable()) {
                    logger.error('loadSources', 'electron Screen selection called but desktopCapturer not available');
                    resolve();
                    return;
                }
                self.appSources = [];
                self.sources = [];

                //we're leaving the sources looping code in below for future implementation, but by changing the sources
                // types from ['window','screen'] to just ['screen'] we're effectively turning off app sharing for
                // electron
                var getSourcesCallback = function (sources) {
                    return Promise.resolve(sources)
                        .then(sources => {
                            logger.log('sources passed to getSourcesCallback', sources);

                            for (var i = 0; i < sources.length; i++) {
                                if (self.isCatalina && self.possibleCatalinaError) {
                                    //check this window to see if we can exclude the error
                                    checkForOtherAppWindow(sources[i]);
                                }

                                const tempSource = {
                                    name: sources[i].name,
                                    id: sources[i].id,
                                    displayId: sources[i].display_id,
                                    dataURL: sources[i].thumbnail.toDataURL(),
                                    iconURL: sources[i].appIcon?.toDataURL()
                                };

                                if (tempSource.id.indexOf('screen:') === 0) {
                                    logger.log(
                                        'loadSources',
                                        'screen: adding screenshare source to list of sources: ',
                                        tempSource
                                    );
                                    self.sources.push(tempSource);
                                } else {
                                    // Skip unwanted window sources
                                    if (shouldSkipSource(sources[i].name)) {
                                        continue;
                                    }

                                    logger.log('loadSources', 'app: before name fix: ', tempSource);
                                    tempSource.name = fixName(tempSource.name);
                                    logger.log(
                                        'loadSources',
                                        'app: adding screenshare source to list of sources: ',
                                        tempSource
                                    );
                                    self.appSources.push(tempSource);
                                }
                            }

                            if (helperService.getIsRedesign() === true && self.sources[0]) {
                                self.clickSource(self.sources[0]);
                            }
                        })
                        .then(() => {
                            return helperService.getElectronVersion() < 7
                                ? self.possibleCatalinaError
                                : !helperService.hasScreenRecordingPermissions();
                        })
                        .then(showError => {
                            self.showCatalinaError = showError;
                            logger.log(
                                'loadSources',
                                'Final state of catalina check: isCatalina :' +
                                    self.isCatalina +
                                    ' possibleCatalinaError:' +
                                    self.possibleCatalinaError
                            );
                        })
                        .then(digest())
                        .catch(error => {
                            logger.error('loadSources', 'Error in getSourcesCallback', error);
                        });
                };

                let getSourcesOptions = getSourceOptions();
                $window.preloadedApi.desktopCapturer
                    .getSources(getSourcesOptions)
                    .then(sources => resolve(getSourcesCallback(sources)));
            });
        }

        function getSourceOptions() {
            let types;
            if (!self.VDIRef.shareApplicationScreen) {
                types = ['screen'];
            } else {
                types = ['screen', 'window'];
            }

            let getSourcesOptions;
            if (helperService.getIsRedesign()) {
                getSourcesOptions = { types: types, fetchWindowIcons: true };
            } else {
                getSourcesOptions = { types: types };
            }

            return getSourcesOptions;
        }

        function close() {
            onHideModal(null, 'electronScreen');
        }

        function isElectronCatalina() {
            if (!helperService.isElectronOnMac()) {
                logger.debug('isElectronCatalina', 'No electron detected in isElectronCatalina');
                return false;
            }

            try {
                var systemInfo = helperService.getSystemInfo();
                var releaseString = systemInfo.osRelease;
                var parts = releaseString.split('.');

                if (parts[0] === '19') {
                    logger.log('isElectronCatalina', 'Found Catalina');
                    return true;
                }
            } catch (err) {
                logger.error('isElectronCatalina', 'Error', err);
            }

            return false;
        }

        function isScreenSource(source) {
            if (!source || !source.id) {
                return false;
            }

            if (source.id.split(':')[0] === 'screen') {
                return true;
            }

            return false;
        }

        function checkForOtherAppWindow(source) {
            if (isOtherAppWindow(source)) {
                self.possibleCatalinaError = false;
            }
        }

        function isOtherAppWindow(source) {
            if (!source || !source.id || !source.name) {
                return false;
            }

            if (source.id.split(':')[0] === 'screen') {
                return false;
            }

            if (
                source.name.toLowerCase().indexOf('developer tools') === 0 ||
                source.name.toLowerCase().indexOf('anymeeting') === 0 ||
                source.name.toLowerCase().indexOf('intermedia unite') === 0 ||
                source.name.toLowerCase().indexOf('elevate uc') === 0 ||
                source.name.toLowerCase().indexOf('| anymeeting') > 0 ||
                source.name.toLowerCase().indexOf('| online meeting') > 0
            ) {
                return false;
            }

            logger.log('isOtherAppWindow', 'Found excluding application window in catalina');
            return true;
        }

        function fixName(name) {
            var maxLength;
            if (helperService.getIsRedesign() === true) {
                maxLength = 23;
            } else {
                //TODO: REMOVE POST-REDESIGN
                maxLength = 22;
            }

            if (!name || name.length <= maxLength) {
                return name;
            }

            return name.substring(0, maxLength - 3) + '...';
        }

        function digest() {
            if (!$scope.$$phase) {
                $scope.$digest();
            }
        }

        function shouldSkipSource(sourceName) {
            if (!sourceName) {
                return false;
            }

            const lowerName = sourceName.toLowerCase();
            const skipNames = ['search pane', 'start menu', 'search', 'immersive background', 'snapped desktop'];

            return skipNames.includes(lowerName);
        }

        ////////////////////////
        // CITRIX V4 FUNCTIONS
        ////////////////////////

        // Citrix V4 main function to load sources
        function loadSources_citrixV4(resolve) {
            logger.log('loadSources_citrixV4', 'Using Citrix SDK V4 for source retrieval');

            // Initialize arrays
            self.sources = [];
            self.appSources = [];

            // Fetch both screen and window sources using VDI reference
            const sourcePromises = [
                self.VDIRef.getScreensAsync().catch(error => {
                    logger.error('loadSources_citrixV4', 'Error fetching screen sources', error);
                    return [];
                }),
                self.VDIRef.getWindowsAsync().catch(error => {
                    logger.error('loadSources_citrixV4', 'Error fetching window sources', error);
                    return [];
                })
            ];

            Promise.all(sourcePromises)
                .then(([screenSources, windowSources]) => {
                    logger.log('loadSources_citrixV4', 'Received sources', {
                        screens: screenSources?.length || 0,
                        windows: windowSources?.length || 0
                    });

                    // Process sources in parallel
                    const processingPromises = [
                        processScreenSources_citrixV4(screenSources || []),
                        processWindowSources_citrixV4(windowSources || [])
                    ];

                    return Promise.all(processingPromises);
                })
                .then(() => {
                    logger.log(
                        'loadSources_citrixV4',
                        'Processed sources - screens: ' + self.sources.length + ', windows: ' + self.appSources.length
                    );

                    // Select first available source
                    selectFirstAvailableSource_citrixV4();

                    digest();
                    resolve();
                })
                .catch(error => {
                    logger.error('loadSources_citrixV4', 'Error in source loading process', error);

                    // Still try to select first available source in case some processing succeeded
                    selectFirstAvailableSource_citrixV4();
                    digest();
                    resolve();
                });
        }

        // Process screen sources with optimized handling
        function processScreenSources_citrixV4(screenSources) {
            if (!screenSources || !screenSources.length) {
                return Promise.resolve();
            }

            const sourcePromises = screenSources.map(source =>
                processSource_citrixV4(source, 'screen', 'Screen')
                    .then(sourceObj => {
                        if (sourceObj) {
                            logger.log('processScreenSources_citrixV4', 'Adding screen source: ' + sourceObj.name);
                            self.sources.push(sourceObj);
                        }
                    })
                    .catch(error => {
                        logger.error('processScreenSources_citrixV4', 'Error processing screen source', error);
                    })
            );

            return Promise.all(sourcePromises);
        }

        // Process window sources with optimized handling
        function processWindowSources_citrixV4(windowSources) {
            if (!windowSources || !windowSources.length) {
                return Promise.resolve();
            }

            const sourcePromises = windowSources.map(source =>
                processSource_citrixV4(source, 'window', 'Window')
                    .then(sourceObj => {
                        if (sourceObj) {
                            // Skip unwanted system sources
                            if (shouldSkipSource(sourceObj.name)) {
                                logger.log(
                                    'processWindowSources_citrixV4',
                                    'Skipping unwanted window source: ' + sourceObj.name
                                );
                                return;
                            }

                            logger.log('processWindowSources_citrixV4', 'Adding window source: ' + sourceObj.name);
                            self.appSources.push(sourceObj);
                        }
                    })
                    .catch(error => {
                        logger.error('processWindowSources_citrixV4', 'Error processing window source', error);
                    })
            );

            return Promise.all(sourcePromises);
        }

        // Common source processing logic with timeout handling
        function processSource_citrixV4(source, sourceType, defaultName) {
            return new Promise(resolve => {
                if (!source || !source.getId) {
                    logger.warn('processSource_citrixV4', 'Invalid ' + sourceType + ' source, skipping');
                    resolve(null);
                    return;
                }

                const sourceName = source.getDescription() || defaultName;
                const sourceId = source.getId();

                // Create the source object
                const sourceObj = {
                    id: sourceType + ':' + sourceId,
                    name: sourceName,
                    display_id: sourceId,
                    displayId: sourceId,
                    dataURL: null,
                    iconURL: null
                };

                // Create promises for preview and icon with timeout
                const imagePromises = [];

                // Add preview promise with timeout
                const previewPromise = Promise.race([
                    getSourcePreview_citrixV4(source),
                    new Promise(resolve => setTimeout(() => resolve(null), 5000)) // 5 second timeout
                ]).then(dataURL => {
                    if (dataURL) {
                        sourceObj.dataURL = dataURL;
                    }
                });
                imagePromises.push(previewPromise);

                // Add icon promise for windows with timeout
                if (sourceType === 'window' && source.getIconImage) {
                    const iconPromise = Promise.race([
                        source.getIconImage(false).then(iconData => imageDataToURL_citrixV4(iconData)),
                        new Promise(resolve => setTimeout(() => resolve(null), 3000)) // 3 second timeout
                    ])
                        .then(iconURL => {
                            if (iconURL) {
                                sourceObj.iconURL = iconURL;
                            }
                        })
                        .catch(error => {
                            logger.error('processSource_citrixV4', 'Error getting ' + sourceType + ' icon', error);
                        });
                    imagePromises.push(iconPromise);
                }

                // Wait for all image promises to complete
                Promise.all(imagePromises)
                    .then(() => resolve(sourceObj))
                    .catch(error => {
                        logger.error('processSource_citrixV4', 'Error processing ' + sourceType + ' images', error);
                        resolve(sourceObj); // Return object even if images failed
                    });
            });
        }

        // Optimized source selection logic
        function selectFirstAvailableSource_citrixV4() {
            if (!helperService.getIsRedesign()) {
                return;
            }

            const firstSource =
                self.sources.length > 0 ? self.sources[0] : self.appSources.length > 0 ? self.appSources[0] : null;

            if (firstSource) {
                try {
                    self.clickSource(firstSource);
                } catch (error) {
                    logger.error('selectFirstAvailableSource_citrixV4', 'Error selecting first source', error);
                }
            }
        }

        // Citrix V4 helper function to convert ImageData to data URL with caching
        function imageDataToURL_citrixV4(imageData) {
            if (!imageData || !imageData.data) {
                return null;
            }

            try {
                const canvas = document.createElement('canvas');
                canvas.width = imageData.width;
                canvas.height = imageData.height;
                const ctx = canvas.getContext('2d');
                ctx.putImageData(imageData, 0, 0);

                // Use lower quality for faster processing if image is large
                const quality = imageData.width * imageData.height > 1920 * 1080 ? 0.7 : 0.9;
                return canvas.toDataURL('image/jpeg', quality);
            } catch (error) {
                logger.error('imageDataToURL_citrixV4', 'Error converting ImageData to data URL', error);
                return null;
            }
        }

        // Citrix V4 helper function to get source preview with improved error handling
        function getSourcePreview_citrixV4(source) {
            // Optimized placeholder - smaller base64 string
            const placeholderDataURL =
                'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgZmlsbD0iI2Y1ZjVmNSIvPjx0ZXh0IHg9IjUwIiB5PSI1NSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZm9udC1mYW1pbHk9IkFyaWFsIiBmb250LXNpemU9IjEyIiBmaWxsPSIjOTk5Ij5ObyBQcmV2aWV3PC90ZXh0Pjwvc3ZnPg==';

            return new Promise(resolve => {
                if (!source || !source.getPreviewImage) {
                    logger.warn('getSourcePreview_citrixV4', 'Source or getPreviewImage not available');
                    resolve(placeholderDataURL);
                    return;
                }

                try {
                    // Add timeout to prevent hanging
                    const timeoutId = setTimeout(() => {
                        logger.warn('getSourcePreview_citrixV4', 'Preview image request timed out');
                        resolve(placeholderDataURL);
                    }, 4000);

                    // Request preview as ImageData for better performance
                    source
                        .getPreviewImage(false)
                        .then(imageData => {
                            clearTimeout(timeoutId);

                            if (!imageData || !imageData.data) {
                                logger.warn('getSourcePreview_citrixV4', 'Empty or invalid image data received');
                                resolve(placeholderDataURL);
                                return;
                            }

                            const dataURL = imageDataToURL_citrixV4(imageData);
                            resolve(dataURL || placeholderDataURL);
                        })
                        .catch(error => {
                            clearTimeout(timeoutId);
                            logger.error('getSourcePreview_citrixV4', 'Error getting preview image', error);
                            resolve(placeholderDataURL);
                        });
                } catch (error) {
                    logger.error('getSourcePreview_citrixV4', 'Exception in getPreviewImage', error);
                    resolve(placeholderDataURL);
                }
            });
        }
    }
]);
